import { Box, BoxProps } from '@amzn/ring-ui-react-components';

export type VerticalDividerProps = BoxProps;

export const VerticalDivider = (props: VerticalDividerProps) => (
  <Box
    borderRightColor="tertiary.500"
    borderRightStyle="solid"
    borderRightWidth={{ base: 0, m: 1 }}
    {...props}
  />
);
